/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetEncumbrance = {
    Yes: 'Yes',
    No: 'No',
    Unknown: 'Unknown'
} as const;
export type AssetEncumbrance = typeof AssetEncumbrance[keyof typeof AssetEncumbrance];


export function instanceOfAssetEncumbrance(value: any): boolean {
    for (const key in AssetEncumbrance) {
        if (Object.prototype.hasOwnProperty.call(AssetEncumbrance, key)) {
            if (AssetEncumbrance[key as keyof typeof AssetEncumbrance] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetEncumbranceFromJSON(json: any): AssetEncumbrance {
    return AssetEncumbranceFromJSONTyped(json, false);
}

export function AssetEncumbranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetEncumbrance {
    return json as AssetEncumbrance;
}

export function AssetEncumbranceToJSON(value?: AssetEncumbrance | null): any {
    return value as any;
}

export function AssetEncumbranceToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetEncumbrance {
    return value as AssetEncumbrance;
}

